import { Client } from '../api-client';

const get3DModels = (batchId: string, subjectId: string, scheduleId: string) =>
  `v3/batches/${batchId}/subject/${subjectId}/schedule/${scheduleId}/three-d-model`;

export const threeDModelFetcher = ({ queryKey }: any) => {
  const { batchId, subjectId, scheduleId } = queryKey[1];
  return Client.get(get3DModels(batchId, subjectId, scheduleId));
};
